const STORAGE_KEY = 'app_sidebar_mounted_v1';

export const loadSidebarMounted = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const saveSidebarMounted = (isMounted) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, isMounted ? 'true' : 'false');
  } catch {
    // ignore quota / privacy errors
  }
};
